import vsComponent from './vsAvatar'

export default Vue => {
  Vue.component(vsComponent.name, vsComponent)
}
